import React, { useContext, useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.scss";
import { useAPI } from "../../../../../shared/services/api/API";
import { OPTIVAL_CONSTANTS } from "../../../../../shared/Constants";
import { useTranslation } from "react-i18next";
import { SkillsContext } from "../../../contexts/SkillsContext";
import { Link } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";

export const BarChart = () => {
  const { t } = useTranslation();
  const { httpGet, handleAlertBar } = useAPI();
  const { updateSkillsBarChartLessMore } = useContext(SkillsContext);
  const [skills, setSkills] = useState<string[]>([]);
  const [seriesData, setSeriesData] = useState<any[]>([]);

  // Register custom horizontal line marker symbol
  Highcharts.SVGRenderer.prototype.symbols.verticalLine = (
    x: any,
    y: any,
    w: any,
    h: any
  ) => {
    const length = h * 5; // vertical length relative to marker height
    const xMid = x + w / 2; // center horizontally
    return ["M", xMid, y - length / 2, "L", xMid, y + length / 2];
  };
  if ((Highcharts as any).VMLRenderer) {
    (Highcharts as any).VMLRenderer.prototype.symbols.verticalLine =
      Highcharts.SVGRenderer.prototype.symbols.verticalLine;
  }

  const getskillsGapChartData = () => {
    const lang = localStorage.getItem(
      OPTIVAL_CONSTANTS.EMPLOYEE_PREFERRED_LANGUAGE
    );
    const queryParams = { pageSize: 4, language: lang };
    httpGet(OPTIVAL_CONSTANTS.API_URLS.GET_SKILLS_WITH_GAP, queryParams).then(
      (res) => {
        if (res?.data?.error) {
          handleAlertBar("error", res.data.message);
        } else if (res?.data) {
          const items = res.data.skillsWithMostGap || [];
          setSkills(items.map((i: any) => i.skillName));
          const achieved = items.map((i: any) => i.achieved);
          const gap = items.map((i: any) => i.gap);
          // const surplus = items.map((i: any) => i.surplus);
          const target = items.map((i: any) => i.target);

          setSeriesData([
//             {
//               name: t("opva.surplus"),
//               data: surplus,
//               color: "#0b245cff",
//               type: "bar",
//             },
            {
              name: t("opva.gap"),
              data: gap,
              color: "#FBE4E8",
              borderColor: "#FF647C",
              type: "bar",
            },
            {
              name: t("opva.achieve"),
              data: achieved,
              color: "#0084F4",
              type: "bar",
            },
            {
              name: t("opva.target"),
              type: "scatter",
              data: target,
              marker: {
                enabled: true,
                symbol: "verticalLine",
                radius: 4,
                lineWidth: 3,
                lineColor: "#00C48C",
                fillColor: null,
              },
              color: "#00C48C",
              enableMouseTracking: true,
              showInLegend: true,
            },
          ]);
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
        }
      }
    );
  };

  useEffect(() => {
    getskillsGapChartData();
  }, []);

  const options = {
    chart: {
      type: "bar",
      backgroundColor: "#fafbfc",
      height: 300,
    },

    title: {
      text: t("opva.topSkillsGapAnalysis"),
      align: "left",
    },
    xAxis: {
      categories: skills,
      gridLineWidth: 1,
      gridLineDashStyle: "dash",
    },

    yAxis: {
      gridLineDashStyle: "dash",
      title: {
        text: "",
      },
    },
    legend: {
      reversed: true,
    },

    tooltip: {
      shared: false,
      formatter: function (this: Highcharts.TooltipFormatterContextObject): string | false {
        if (this.series.type === 'scatter') {
          return `<b>${this.series.name}</b>: ${this.y}`;
        } else if (this.series.type === 'bar') {
          return `<b>${this.series.name}</b>: ${this.y}`;
        }
        return false;
      }
    },

    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: false
        }
      },
      scatter: {
        marker: {
          enabled: true,
          radius: 1,
        },
        stickyTracking: false,
      }
    },

    series: seriesData,
  };

  return (
    <div className="bar-chart-container">
      <div style={{ position: "absolute", top: 20, right: 20, zIndex: 1 }}>
        <Link
          component="button"
          color="#000"
          title="expand"
          onClick={() => updateSkillsBarChartLessMore(true)}
        >
          <OpenInFullIcon fontSize="small" />
        </Link>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
